var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmpresas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15V0H8.33333V3.33333H16.6667V15H0ZM1.66667 13.3333H6.66667V11.6667H1.66667V13.3333ZM1.66667 10H6.66667V8.33333H1.66667V10ZM1.66667 6.66667H6.66667V5H1.66667V6.66667ZM1.66667 3.33333H6.66667V1.66667H1.66667V3.33333ZM8.33333 13.3333H15V5H8.33333V13.3333ZM10 8.33333V6.66667H13.3333V8.33333H10ZM10 11.6667V10H13.3333V11.6667H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpresas);
export default __webpack_public_path__ + "static/media/icon-Empresas.31704d06d6d721c37bbc8c49a71726f9.svg";
export { ForwardRef as ReactComponent };